














































































import { Component, Watch, Vue } from "vue-property-decorator";
import MenuManager from "@/components/MenuManager.vue";
import Newsletter from "@/components/Newsletter.vue";
import { UtilitiesFunctions } from "@/helpers";

@Component({
  components: {
    MenuManager,
    Newsletter
  }
})
export default class Footer extends Vue {
  menuItems: Array<any> = [];
  handleRoute = UtilitiesFunctions.handleRoute;

  @Watch("$i18n.locale", { immediate: true, deep: true })
  onLangChanged(val: string) {
    this.setMenuItems();
  }

  mounted() {
    this.setMenuItems();
  }

  handleBusiness() {
    window.open(
      'https://business.divinea.com',
      '_blank');

  }

  setMenuItems() {
    this.menuItems = [
      /*{
        label: this.$t("footer.menu.who"),
        link: "about"
      },*/
      {
        label: this.$t("footer.menu.blog"),
        link: this.$t("footer.menu.linkBlog")
      },
      {
        label: this.$t("footer.menu.help"),
        link: "nolink"
      },
      {
        label: this.$t("footer.menu.terms"),
        link: "terms"
      },
      {
        label: this.$t("footer.menu.privacy"),
        link: "privacy"
      },
      {
        label: this.$t("footer.menu.contacts"),
        link: "contacts"
      }
    ];
  }

  openClientEmail() {
    location.href = "mailto:hello@divinea.com";
  }
}
